import React, { useEffect, useState,useCallback } from 'react'
import './style.css'
import { Chip } from 'primereact/chip';
import { useNavigate,useParams } from "react-router-dom";
import categoriesIcon from '../../../assets/icons/category.svg';
import ProfileIntiationLablesContainer from '../../../components/DashboardComponents/ProfileIntiationLablesContainer';
import PostRequest from '../../../service/PostRequest';
import FormSeperator from '../../../components/LoginFormComponents/FormSeperator';
import { Button } from 'primereact/button';
import InputFieldText from '../../../components/Widgets/Inputs/InputFieldText';
import InputFeildTextArea from '../../../components/Widgets/Inputs/InputFeildTextArea';

const AddCategoryPage = ({ setActivePath , header, description, headerActionName, headerActionNavigationLink, isSaveAndContinueRequired, saveButtonNavigationLink}) => {
  const navigate = useNavigate();
  const { branchId } = useParams();
  const [categoryName, setCategoryName] = useState('');
  const [categoryDescription, setCategoryDescription] = useState('');
  const [categoryNameAsText, setCategoryNameAsText] = useState('');
  const [categoryDescriptionAsText, setCategoryDescriptionAsText] = useState('');
  const [addedCategories, setAddedCategories] = useState([]);

  // Define all categories
  const restaurantCategories = [
    { label: 'Rice Dishes', description: 'Various dishes where rice is a primary ingredient, including fried rice, rice bowls, and more.' },
    { label: 'Main Courses', description: 'Hearty dishes typically served as the main part of a meal, including meats, pasta, and casseroles.' },
    { label: 'Appetizers', description: 'Small dishes served before the main course, such as soups, salads, and finger foods.' },
    { label: 'Desserts', description: 'Sweet dishes typically served at the end of a meal, including cakes, ice cream, and pastries.' },
    { label: 'Beverages', description: 'Drinks, both alcoholic and non-alcoholic, including sodas, juices, coffee, tea, and cocktails.' },
    { label: 'Salads', description: 'Dishes primarily made of raw or cooked vegetables, often served with a dressing.' },
    { label: 'Soups', description: 'Liquid dishes served warm or cold, typically made by boiling ingredients like vegetables, meat, or fish in broth.' },
    { label: 'Seafood', description: 'Dishes made with fish, shrimp, crab, and other sea creatures.' },
    { label: 'Vegetarian', description: 'Dishes that do not contain meat, often focusing on vegetables, grains, and legumes.' },
    { label: 'Vegan', description: 'Dishes made without any animal products, including meat, dairy, and eggs.' },
    { label: 'Snacks', description: 'Light, easy-to-eat foods typically enjoyed between meals, such as chips, nuts, and small pastries.' },
    { label: 'Breakfast', description: 'Dishes typically served in the morning, including eggs, pancakes, cereal, and pastries.' },
  ];

  const hotelCategories = [
    { label: 'Accommodation', description: 'Rooms or suites available for lodging.' },
    { label: 'Room Service', description: 'Food and drink service delivered to guests in their rooms.' },
    { label: 'Dining', description: 'Food and beverage options available within the hotel.' },
  ];

  const barbershopCategories = [
    { label: 'Haircuts', description: 'Cutting or styling of hair.' },
    { label: 'Shaves', description: 'Shaving facial hair.' },
    { label: 'Beard Trims', description: 'Trimming or shaping of beards.' },
  ];

  const teaShopCategories = [
    { label: 'Loose Leaf Teas', description: 'Tea leaves sold loose, without packaging.' },
    { label: 'Tea Blends', description: 'Mixtures of different types of tea leaves or herbs.' },
    { label: 'Herbal Teas', description: 'Teas made from dried herbs, flowers, or fruits.' },
  ];

  const snacksShopCategories = [
    { label: 'Chips', description: 'Crunchy snack made from sliced, fried, or baked potatoes.' },
    { label: 'Popcorn', description: 'Popped corn kernels, often flavored or seasoned.' },
    { label: 'Nuts', description: 'Edible seeds with a hard shell.' },
  ];

  const groceryStoreCategories = [
    { label: 'Fresh Produce', description: 'Fruits, vegetables, and other perishable food items.' },
    { label: 'Meat and Seafood', description: 'Fresh or frozen meat and seafood products.' },
    { label: 'Dairy Products', description: 'Milk, cheese, yogurt, and other dairy items.' },
  ];

  const supermarketCategories = [...groceryStoreCategories]; // Assuming similar categories

  const pharmacyCategories = [
    { label: 'Prescription Medications', description: 'Medications that require a doctor\'s prescription.' },
    { label: 'Over-the-Counter Medications', description: 'Medications available without a prescription.' },
    { label: 'Vitamins and Supplements', description: 'Dietary supplements and vitamin products.' },
  ];

  const allCategories = [
    ...restaurantCategories,
    ...hotelCategories,
    ...barbershopCategories,
    ...teaShopCategories,
    ...snacksShopCategories,
    ...groceryStoreCategories,
    ...supermarketCategories,
    ...pharmacyCategories,
  ];

   // useCallback for addCategory
   const addCategory = useCallback(async () => {
    if (!categoryName || !categoryDescription) {
      return; // Exit early if either name or description is empty
    }

    const data = {
      name: categoryName,
      description: categoryDescription,
    };

    try {
      const response = await PostRequest(`v1/inventory-service/branch/${branchId}/add/category`, data, true);
      console.log('Success:', response);
      const newCategory = { label: categoryName, description: categoryDescription };
      setAddedCategories((prevCategories) => [...prevCategories, newCategory]);
      setCategoryName(''); // Clear input fields after successful addition
      setCategoryDescription('');
    } catch (error) {
      console.error('Error adding category:', error);
    }
  }, [branchId, categoryName, categoryDescription]);


  const addCategoryAsInput = useCallback(async () => {
    if (!categoryNameAsText || !categoryDescriptionAsText) {
      return; // Exit early if either name or description is empty
    }

    const data = {
      name: categoryNameAsText,
      description: categoryDescriptionAsText,
    };

    try {
      const response = await PostRequest(`v1/inventory-service/branch/${branchId}/add/category`, data, true);
      console.log('Success:', response);
      const newCategory = { label: categoryNameAsText, description: categoryDescriptionAsText };
      setAddedCategories((prevCategories) => [...prevCategories, newCategory]);
      setCategoryNameAsText(''); // Clear input fields after successful addition
      setCategoryDescriptionAsText('');
    } catch (error) {
      console.error('Error adding category:', error);
    }
  }, [branchId, categoryNameAsText, categoryDescriptionAsText]);



  const handleCategoryNameChange = (e) => {
    setCategoryNameAsText(e.target.value);
  };


  const handleCategoryDescriptionChange = (e) => {
    setCategoryDescriptionAsText(e.target.value);
  };


  const chooseCategory = (selectedCategoryName, categoryDescription) => {
    const isAlreadyAdded = addedCategories.some((category) => category.label === selectedCategoryName);
    if (!isAlreadyAdded) {
      setCategoryName(selectedCategoryName);
      setCategoryDescription(categoryDescription);
    }
  };

  const removeCategory = (indexToRemove) => {
    const updatedCategories = addedCategories.filter((_, index) => index !== indexToRemove);
    setAddedCategories(updatedCategories);
  };

  useEffect(() => {
    setActivePath('Branches');
  }, [setActivePath, addedCategories]);

  useEffect(() => {
    if (categoryName && categoryDescription) {
      addCategory(); // Call addCategory() only when both name and description are set
    }
  }, [categoryName, categoryDescription, addCategory]);

  const renderAddedCategories = () => {
    return addedCategories.map((addedCategory, index) => (
      <Chip
        key={index}
        label={addedCategory.label}
        variant="outlined"
        color="primary"
        style={{ marginRight: '5px', marginBottom: '5px' }}
        removable
        onRemove={() => removeCategory(index)} // Delete the category on delete icon click
      />
    ));
  };

  return (
    <div className="outlet-container">
      <div className="background-white">
        <div className="background-white-sub-container">                  <br/>

        <ProfileIntiationLablesContainer title="Add New Category" description="Add store details like color, font theme etc" status={true}  icon={categoriesIcon} iconBackgroundColor="#CE7B69"/>


     <br/>
     {/* <BranchDetailsInfoContainer branchId={branchId}/> */}
     <FormSeperator content="Choose categories from the list"/>

     {allCategories.map((category, index) => (
        <Chip
          key ={index}
          label={category.label}
          color="primary"
          onClick={() => chooseCategory(category.label, category.description)}
          style={{ marginRight: '5px', marginBottom: '5px' }} // Add margin bottom and right to create a gap between each Chip
        />
       
    ))}
    <FormSeperator content="Selected categories"/>



     {addedCategories.length === 0 ? (
        <p style={{ textAlign: 'center' }}>No categories selected or added. Please add or choose a category.</p>
      ) : (
        renderAddedCategories()
      )}
      <br/><br/>
      <FormSeperator content="If not listed, add manually"/>
                  <div className='flex-input-container'>
                <InputFieldText value={categoryNameAsText} onChange={handleCategoryNameChange} label="Enter the category Name"/>
                <InputFeildTextArea value={categoryDescriptionAsText} onChange={handleCategoryDescriptionChange} label="Enter the category Description"/>
                <Button onClick={addCategoryAsInput} className='login-form-btn'label="Add"/>

                  </div>

    
                  <Button onClick={() => navigate("/store/branch/list/categories")} variant="contained" label="Save and Continue"/>

         
    </div><br/><br/>
          </div>
        </div>
        



  )
}

export default AddCategoryPage;
